<puro-modal
  class="how-to-measure-dialog__modal"
  [className]="'how-to-measure-dialog__modal'"
  [open]="open()"
  [title]="modalTitle()"
  size="large"
  [showCloseButton]="true"
  [closeOnBackdrop]="true"
  [actions]="closeActions()"
  (closeModal)="onClose()"
>
  <div class="how-to-measure-dialog">
    <puro-typography variant="body1" component="p" class="how-to-measure-dialog__body">
      {{ 'createShipment.packageStep.measureModal.body' | translate }}
    </puro-typography>

    <div class="how-to-measure-dialog__grid">
      @for (item of measureItems; track item.titleKey) {
        <figure class="how-to-measure-dialog__item">
          <puro-typography variant="h4" component="h3" color="secondary" align="center">
            {{ item.titleKey | translate }}
          </puro-typography>
          <img
            [src]="item.imagePath"
            [attr.alt]="item.altKey | translate"
            width="300"
            height="180"
          />
        </figure>
      }
    </div>
  </div>
</puro-modal>
